import styled from 'styled-components';
import Theme from '../../../styles/models/theme';
import CommonBtn from '../Buttons/CommonBtn';

export const Container = styled.div<{theme?: Theme}>`
  background-color: ${({theme}) => 'green'};
  border-color: ${({theme}) => theme.primary};
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
`;

export const Text = styled.h1<{theme?: Theme; type: string}>`
  color: ${({theme}) => theme.darkText};
  font-size: 16px;
  font-weight: ${({type}) => type};
`;

export const Button = styled(CommonBtn)`
  width: 50%;
`;
